export const iconFontAwesomeMoneyBrazilianRealSign = (
	<i className="fa-solid fa-brazilian-real-sign"></i>
);
